import React from 'react'

// evertel
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@evertel/web/ui'

interface DisableConnectorModalProps {
    visible: boolean
    loading: boolean
    onClose: () => void
    onConfirm: () => void
}

const DisableConnectorModal: React.FC<DisableConnectorModalProps> = ({
    visible,
    loading,
    onClose,
    onConfirm
}) => {

    return (
        <Modal
            visible={visible}
            onClose={onClose}
            size="lg"
        >
            <ModalHeader
                title="Disable an external Connector in this room?"
            />
            <ModalBody>
                <p className="mb-3">
                    When you disable an external connector for this room, messages, media, and files shared here will stop being delivered to connected external systems.
                </p>
                <p className="mb-0">
                    This also removes any content that has already been sent outside Evertel from this room. Access and retention for previously shared data should still be managed in those external systems according to your agency’s policies.
                </p>
            </ModalBody>
            <ModalFooter align="right">
                <Button
                    color="link"
                    outline
                    className="me-2"
                    onClick={onClose}
                >
                    Cancel
                </Button>
                <Button
                    color="primary"
                    onClick={onConfirm}
                    loading={loading}
                >
                    Disable Connector
                </Button>
            </ModalFooter>
        </Modal>
    )
}

DisableConnectorModal.displayName = 'DisableConnectorModal'

export { DisableConnectorModal }
